import { Widget, WidgetProps } from "@rjsf/core";

import { FormMessage, TextArea } from "@xometry/xometry_loft";
import { FormContext } from "../types";

import { LabelWithOptionalFlag } from "./LabelWithOptionalFlag";
import { Section } from "./Shared.style";

export const LoftTextAreaField: Widget = ({
  disabled,
  onBlur,
  onChange,
  options,
  rawErrors,
  required,
  schema,
  value,
  uiSchema,
  placeholder,
  formContext,
}: WidgetProps) => {
  const isInvalid = !!(rawErrors?.length > 0 && options?.touched);
  const { scale } = formContext as FormContext;
  return (
    <div css={Section}>
      <LabelWithOptionalFlag
        required={required}
        tooltip={(options?.tooltip || "") as string}
      >
        {schema.title}
      </LabelWithOptionalFlag>
      <TextArea
        style={{ resize: "vertical" }}
        defaultValue={value}
        disabled={disabled}
        invalid={isInvalid}
        placeholder={placeholder}
        name={options?.name as string}
        onChange={(e: React.FormEvent<HTMLTextAreaElement>) => {
          onChange(e.currentTarget.value || undefined);
        }}
        onBlur={(e: React.FormEvent<HTMLTextAreaElement>) =>
          onBlur(
            e.currentTarget?.name,
            e.currentTarget?.value || (undefined as any)
          )
        }
        scale={scale}
      />
      {uiSchema?.description && (
        <FormMessage>{uiSchema.description}</FormMessage>
      )}
      {isInvalid && (
        <FormMessage invalid>{rawErrors ? rawErrors[0] : ""}</FormMessage>
      )}
    </div>
  );
};
